module.exports = function() {
  return new Worker(__webpack_public_path__ + "f95c105e11f7f663debd.worker.js");
};